import { appUrl } from 'utils/wrappers';

import Base from 'app/models/base';

export default Base.extend({
  urlRoot() { return appUrl(`reports/${this.reportType}`); },

  fetch(options) {
    const thisOptions = { data: { mode: this.escape('mode') }, ...options };
    Base.prototype.fetch.call(this, thisOptions);
  },
});



// WEBPACK FOOTER //
// ./app/models/report_base.js